import React, { useState, useRef, useEffect } from "react";
import {
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Step,
  StepButton,
  StepLabel,
  Stepper,
} from "@mui/material";
import {
  Close as CloseIcon,
  PermIdentityOutlined as PermIdentityOutlinedIcon,
  Person3Outlined as Person3OutlinedIcon,
  CallOutlined as CallOutlinedIcon,
  LocationOnOutlined as LocationOnOutlinedIcon,
} from "@mui/icons-material";
import { withSnackbar } from "notistack";

import AutoComplete from "components/Custom/AutoComplete";
import Btn from "components/Custom/Btn";
import TxtBox from "components/Custom/TxtBox";
import ExcelGrid from "components/Custom/ExcelGrid";
import HGraph from "components/Custom/HGraph";
import SkeletonBox from "components/Custom/SkeletonBox";

import { LABELS, SUCCESS, WARNINGS } from "common/lables";
import { COMMON_JS } from "common/scripts";
import { DateFunctions } from "common/datefunctions";
import { GRAPH_TYPES, NOTIFY } from "common/config";
import { CUSTOMER_APIs } from "apihandlers/customer";
import { TRANS_APIs } from "apihandlers/transaction";
import { MASTER_APIs } from "apihandlers/master";
import { USER_APIs } from "apihandlers/user";
import { COLORS } from "common/colors";

const DataDetailsRightSide = (props: any) => {
  const {
    dealers,
    dealersRef,
    setShowCustomerCluster,
    selectedCustomers,
    setTransferring,
    tripDelivery,
    setTripDelivery,
    onLocationUpdate,
    polyEdits,
    plottings,
    setPlottings,
    showUser,
    setShowUser,
    usersData,
    plotDetail,
    setTrackedUsers,
    getUsersOnMap,
    setShowMarker,
    customers,
    setCustomers,
    details,
    setDetails,
    setShowTripDelivery,
    transferring,
    setPolyEdits,
    reloadTerritories,
    showTripDelivery,
  } = props;

  const tripRef: any = useRef(null);
  const vehiclesRef: any = useRef(null);
  const driverRef: any = useRef(null);
  const usersRef: any = useRef(null);
  const userTrackDealerRef: any = useRef(null);

  const [driversData, setDriversData] = useState<any>(null);
  const [vehiclesData, setVehiclesData] = useState<any>(null);
  const [tripsData, setTripsData] = useState<any>(null);
  const [activeStep, setActiveStep] = React.useState(0);

  const [rows, setRows] = useState<any>([
    {
      slNo: 1,
      year: "Year",
      sales: "Sales",
    },
    {
      slNo: 1,
      year: "Year",
      sales: "Sales",
    },
  ]);
  const [completed, setCompleted] = React.useState<{
    [k: number]: boolean;
  }>({});

  const columns = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "19.7%",
      type: "number",
      align: "center",
      headerAlign: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "areaName",
      name: LABELS.YEAR,
      width: "40%",
      type: "text",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "cityName",
      name: LABELS.SALES,
      width: "40%",
      type: "text",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
  ];

  const shops = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "12%",
      type: "number",
      align: "center",
      headerAlign: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "name",
      name: LABELS.SHOP_NAME,
      width: "27%",
      type: "text",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "incharge",
      name: LABELS.SHOP_OWNER,
      width: "29%",
      type: "text",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "mobileno",
      name: LABELS.MOBILE_NO,
      width: "30%",
      type: "text",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
  ];

  useEffect(() => {
    if (showTripDelivery) {
      getTrips();
    }
  }, [showTripDelivery]);

  const getTrips = async () => {
    const args = { activeStatus: "true" };
    const res: any = await TRANS_APIs.getTrips(args);
    const { status, response } = res;
    if (status === 200) {
      let list = response.records.map((r: any) => {
        return {
          id: r.id,
          label: r.indentNo,
        };
      });
      setTripsData(list);
      getDrivers();
    }
  };

  const getDrivers = async () => {
    const args = { activeStatus: "true" };
    const res: any = await MASTER_APIs.getDrivers(args);
    const { status, response } = res;
    if (status === 200) {
      const driver = response.records;
      let list = driver.map((r: any) => {
        return {
          id: r.id,
          label: r.driverName,
        };
      });
      setDriversData(list);
      getVehicles(); // for dropdown
    }
  };

  const getVehicles = async () => {
    const args = { activeStatus: "true" };
    const res: any = await MASTER_APIs.getVehicles(args);
    const { status, response } = res;
    if (status === 200) {
      let list = response.records.map((r: any) => {
        return {
          id: r.id,
          label: r.vehicleNumber,
        };
      });
      setVehiclesData(list);
    }
  };

  // const getRows = () => {
  // let list = customers;
  // for (let i = 0; i < customers.length; i++) {
  //   list[i]["slNo"] = i + 1;
  // }
  // setShopRows(list);
  // setLoading(true);
  // };

  const onTransfer = async () => {
    const orgId = dealersRef.current.selectedValue.id;
    if (!orgId) {
      COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.SELECT_TRANSFER_TO);
      return;
    }
    const args = {
      customers: selectedCustomers.map((c) => c.id),
      orgId,
    };
    setTransferring(true);
    try {
      const res = await CUSTOMER_APIs.transferCustomers(args);
      console.log("transferCustomers:", res);
      if (res.status === 200) {
        const res2 = await CUSTOMER_APIs.drawOuterMost({});
        console.log("drawOuterMost:", res2);
        if (res2.status === 200) {
          // reload territories
          COMMON_JS.clearLayers();
          COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.TRANSFER_SUCCESS);
          reloadTerritories();
          setTransferring(false);
        }
      }
    } catch (error) {
      console.log("transferCustomers: error:", error);
    }
  };

  const getTripDeliveries = () => {
    const indentId = tripRef.current.selectedValue.id;
    const fromDt = (document.getElementById("fromDt") as HTMLInputElement)
      .value;
    const toDt = (document.getElementById("toDt") as HTMLInputElement).value;
    const userId = driverRef.current.selectedValue.id;
    const vehicleId = vehiclesRef.current.selectedValue.id;
    const args = {
      indentId,
      fromDt,
      toDt,
      userId,
      vehicleId,
    };
    TRANS_APIs.getLoadingPtComments(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        const deliveries = response.records.map((delivery, i) => {
          return {
            ...delivery,
            lat: Number(delivery.latitude),
            lng: Number(delivery.longitude),
          };
        });
        for (let i = 0; i < deliveries.length; i++) {
          //if vertices is given then polygon will show and even if lat,lng and vertices both present then vertices will be considered is given
          if (deliveries[i].vertices) {
            let vertices = JSON.parse(deliveries[i].vertices).map((point) => {
              point[0] = Number(point[0]);
              point[1] = Number(point[1]);
              return point;
            });
            deliveries[i].vertices = vertices;
          }
          //if lat lng is given then this condition will run
          else if (
            !isNaN(deliveries.lat) &&
            !isNaN(deliveries.lng) &&
            deliveries.lat !== null &&
            deliveries.lng !== null
          ) {
          } else {
            deliveries[i].vertices = [];
          }
        }
        setDetails(true);
        setTripDelivery(deliveries);
      }
    });
  };

  //stepper on click
  const handleStep = (step: number, detail: any) => () => {
    setActiveStep(step);
    onLocationUpdate(detail);
  };

  const getUserTrack = async () => {
    setShowMarker(true);
    const trackedUserId = usersRef.current.selectedValue.id;
    const trackedOrgId = userTrackDealerRef.current.selectedValue.id;
    const userFromDate = (
      document.getElementById("userFromDate") as HTMLInputElement
    ).value;
    try {
      const args = {
        fromDt: userFromDate,
        userId: trackedUserId, //3336 (trackedUserId)
        orgId: trackedOrgId, // 87(trackedOrgId)
      };
      const res: any = await USER_APIs.getUserTrack(args);
      if (res.status === 200) {
        const trackedUserData = res.response;
        console.log("trackedUserData: ", trackedUserData);

        setTrackedUsers(trackedUserData);
      }
    } catch (error) {
      console.log("getUserTrack: ", error);
    }
  };

  const handleDealersChange = async (e, f) => {
    if (f.id) {
      const res = await getUsersOnMap(f.id);
    }
  };
  const columnChart = {
    chart: {
      type: "column",
    },
    title: {
      text: "",
      align: "left",
    },

    xAxis: {
      categories: ["USA", "China", "Brazil", "EU", "India", "Russia"],
      crosshair: true,
    },
    yAxis: {
      min: 0,
      title: {
        text: "y",
      },
    },
    tooltip: {
      valueSuffix: " (1000 MT)",
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
      },
    },
    series: [
      {
        name: "Corn",
        data: [406292, 260000, 107000, 68300, 27500, 14500],
      },
      {
        name: "Wheat",
        data: [51086, 136000, 5500, 141000, 107180, 77000],
      },
    ],
  };

  const pieChart = {
    chart: {
      type: "pie",
      options3d: {
        enabled: true,
        alpha: 45,
        beta: 0,
      },
    },
    title: {
      text: " ",
      align: "left",
    },

    accessibility: {
      point: {
        valueSuffix: "%",
      },
    },
    tooltip: {
      pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        depth: 35,
        dataLabels: {
          enabled: true,
          format: "{point.name}",
        },
      },
    },
    series: [
      {
        type: "pie",
        name: "Share",
        data: [
          ["Samsung", 23],
          ["Apple", 18],
          {
            name: "Xiaomi",
            y: 12,
            sliced: true,
            selected: true,
          },
          ["Oppo*", 9],
          ["Vivo", 8],
          ["Others", 30],
        ],
      },
    ],
  };

  // setShopRows(customers);
  const getCustomerCluster = (p) => {
    if (p.routeName === "route") {
      setShowCustomerCluster(true);
    } else {
      setShowCustomerCluster(false);
    }
  };

  return (
    <>
      {(showUser || polyEdits || showTripDelivery || plottings) && (
        <div
          className="editDetailDiv"
          style={{
            height: window.innerHeight * 0.97,
          }}
        >
          {polyEdits && (
            <>
              <div className="transferHead">
                <div>
                  <h4 className="transferCustomer">
                    {LABELS.TRANSFER_CUSTOMERS}
                  </h4>
                </div>
                <div>
                  <IconButton
                    aria-label="close"
                    onClick={() => {
                      setPolyEdits(false);
                      COMMON_JS.clearLayers();
                      setDetails(false);
                    }}
                    style={{ marginRight: "0.7rem" }}
                  >
                    <CloseIcon />
                  </IconButton>
                </div>
              </div>
              <div
                className="formGroup red width80"
                style={{
                  marginTop: 10,
                  marginBottom: 0,
                }}
              >
                <label>
                  {LABELS.TRANSFER_TO}
                  {<span className="red">*</span>}
                </label>
                <AutoComplete list={dealers} childRef={dealersRef} />
              </div>
              <div className="transferBtn ">
                <Btn
                  text={transferring ? LABELS.TRANSFERING : LABELS.TRANSFER}
                  loading={transferring}
                  onClick={onTransfer}
                  bgColor={COLORS.SAVE_GREEN}
                />
              </div>
              <div className="transferList">
                {selectedCustomers.map((cust, i) => {
                  return (
                    <div key={cust.id + "-" + i}>
                      <h4>{i + 1 + ". " + cust.name}</h4>
                    </div>
                  );
                })}
              </div>
            </>
          )}

          {showTripDelivery && (
            <>
              <div className="transferHead">
                <div>
                  <h4 className="transferCustomer">{LABELS.TRIP_DELIVERIES}</h4>
                </div>
                <div>
                  <IconButton
                    aria-label="close"
                    onClick={() => {
                      setShowTripDelivery(false);
                    }}
                    style={{ marginRight: "0.7rem" }}
                  >
                    <CloseIcon />
                  </IconButton>
                </div>
              </div>
              <div className="tripDeliveryInputs">
                <div className=" flexRowJustify">
                  <div className="formGroup width45">
                    {LABELS.FROM}

                    <TxtBox
                      type={"date"}
                      id="fromDt"
                      defaultValue={DateFunctions.getDate(
                        "today",
                        "from",
                        "YYYY-MM-DD"
                      )}
                    />
                  </div>
                  <div className="formGroup width45">
                    {LABELS.TO}

                    <TxtBox
                      type={"date"}
                      id="toDt"
                      defaultValue={DateFunctions.getDate(
                        "thismonth",
                        "to",
                        "YYYY-MM-DD"
                      )}
                    />
                  </div>
                </div>
                <div className="formGroup ">
                  {LABELS.SELECT_TRIP}

                  <AutoComplete
                    list={tripsData}
                    childRef={tripRef}
                    placeholder={LABELS.SELECT_TRIP}
                  />
                </div>

                <div className="formGroup ">
                  {LABELS.VEHICLE_NUMBER}

                  <AutoComplete
                    list={vehiclesData}
                    childRef={vehiclesRef}
                    placeholder={LABELS.SELECT_VEHICLE}
                  />
                </div>
                <div className="formGroup ">
                  {LABELS.DRIVER_NAME}

                  <AutoComplete
                    list={driversData}
                    childRef={driverRef}
                    placeholder={LABELS.SELECT_DRIVER}
                  />
                </div>
                <div className="flexRowJustify siderBarBtns">
                  <div></div>
                  <Btn
                    paddingLeft={10}
                    paddingRight={10}
                    text={LABELS.LOAD_DATA}
                    onClick={getTripDeliveries}
                    bgColor={COLORS.SAVE_GREEN}
                  />
                  <div></div>
                </div>
              </div>

              {details && (
                <div className="tripDeliveryMainDiv">
                  <div className="formGroup" style={{ textAlign: "center" }}>
                    <h3>{LABELS.TRIP_STATUS}</h3>
                  </div>
                  <div className="tripDeliveryChildDiv">
                    <Stepper
                      nonLinear
                      orientation="vertical"
                      activeStep={activeStep}
                    >
                      {tripDelivery.map((detail, index) => (
                        <Step
                          key={detail.enteredOn + index}
                          completed={completed[index]}
                        >
                          <StepButton
                            color="inherit"
                            onClick={handleStep(index, detail)}
                          >
                            <StepLabel>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <div>{detail.areaName}</div>
                              </div>
                              <div>{detail.enteredOn}</div>
                              {detail.deliveryComments}
                            </StepLabel>
                          </StepButton>
                        </Step>
                      ))}
                    </Stepper>
                  </div>
                </div>
              )}
            </>
          )}
          {plottings && (
            <>
              <div className="transferHead">
                <div>
                  <h4 className="transferCustomer">
                    {LABELS.ZONES_AND_PATH_DETAILS}
                  </h4>
                </div>
                <div>
                  <IconButton
                    aria-label="close"
                    onClick={() => {
                      setCustomers([]);
                      setPlottings(false);
                      getCustomerCluster(plotDetail);
                      COMMON_JS.clearLayers();
                    }}
                    style={{ marginRight: "0.7rem" }}
                  >
                    <CloseIcon />
                  </IconButton>
                </div>
              </div>
              <div className="zoneRouteDiv">
                <div className="zoneRouteDetails">
                  <h3> {plotDetail.name}</h3>

                  <div className="coDetails">
                    <List className="sideBarData">
                      <ListItem>
                        <ListItemIcon>
                          <LocationOnOutlinedIcon sx={{ color: "blue" }} />
                        </ListItemIcon>
                        <ListItemText>
                          {"Bannanje, Udupi, Karnataka 576101"}
                        </ListItemText>
                      </ListItem>

                      <ListItem>
                        <ListItemIcon>
                          <Person3OutlinedIcon sx={{ color: "blue" }} />
                        </ListItemIcon>
                        <ListItemText>{"Srinivas Vonna"}</ListItemText>
                      </ListItem>

                      <ListItem>
                        <ListItemIcon>
                          <PermIdentityOutlinedIcon sx={{ color: "blue" }} />
                        </ListItemIcon>
                        <ListItemText>
                          {"Kuldeep Premkishor Shukla"}
                        </ListItemText>
                      </ListItem>

                      <ListItem>
                        <ListItemIcon>
                          <CallOutlinedIcon sx={{ color: "blue" }} />
                        </ListItemIcon>
                        <a href={`tel:${8726665565}`}>
                          <ListItemText style={{ color: "black" }}>
                            {"8726665565"}
                          </ListItemText>
                        </a>
                      </ListItem>
                    </List>
                  </div>

                  <div className="excelGridDiv">
                    <h3>{LABELS.ROUTE_DETAILS}</h3>
                    <div>
                      {customers ? (
                        <ExcelGrid
                          id={"shops"}
                          height={window.innerHeight * 0.3}
                          cols={shops}
                          rows={customers}
                          exportOption={true}
                          newRowOption={false}
                          exportName={LABELS.AREA}
                        />
                      ) : (
                        <div>
                          <SkeletonBox
                            width={"96%"}
                            height={window.innerHeight * 0.3}
                          />
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="excelGridDiv">
                    <h3>{LABELS.REPORT}</h3>
                    <div>
                      <ExcelGrid
                        id={"area"}
                        height={window.innerHeight * 0.3}
                        cols={columns}
                        rows={rows}
                        exportOption={true}
                        newRowOption={false}
                        exportName={LABELS.AREA}
                      />
                    </div>
                  </div>
                  {/* <hr />   */}
                  <div className="charts">
                    <h3>{LABELS.ANALYTICS}</h3>
                    <div className="highChartSidebar">
                      <HGraph
                        width={"100%"}
                        height={"100%"}
                        type={GRAPH_TYPES.COLUMN}
                        float={"right"}
                        title={"Column Graph"}
                        exportTitle={"Column Graph Record"}
                        xAxisTitle=""
                        yAxisTitle="Leads"
                        graphData={columnChart}
                      />
                    </div>
                    <div className="pieChartSidebar">
                      <HGraph
                        title={"States"}
                        type={GRAPH_TYPES.PIE}
                        exportTitle={"Chart"}
                        width={"85%"}
                        height={"60%"}
                        graphData={pieChart}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
          {showUser && (
            <>
              <div className="transferHead">
                <div>
                  <h4 className="transferCustomer">{LABELS.TRACK_USERS}</h4>
                </div>
                <div>
                  <IconButton
                    aria-label="close"
                    onClick={() => {
                      setShowUser(false);
                      setShowMarker(false);
                    }}
                    style={{ marginRight: "0.7rem" }}
                  >
                    <CloseIcon />
                  </IconButton>
                </div>
              </div>
              <div style={{ width: "80%" }}>
                <div className="formGroup ">
                  <div className="trackUsers"> {LABELS.SELECT_DEALER}</div>
                  <AutoComplete
                    list={dealers}
                    childRef={userTrackDealerRef}
                    placeholder={LABELS.SELECT_USER}
                    onChange={handleDealersChange}
                  />
                </div>
                <div className="formGroup ">
                  {LABELS.SELECT_USER}
                  <AutoComplete
                    list={usersData}
                    childRef={usersRef}
                    placeholder={LABELS.SELECT_USER}
                  />
                </div>
                <div className="formGroup ">
                  {LABELS.DATE}
                  <TxtBox
                    type={"date"}
                    id="userFromDate"
                    defaultValue={DateFunctions.getDate(
                      "today",
                      "from",
                      "YYYY-MM-DD"
                    )}
                  />
                </div>
                {/* <div className="formGroup width45">
                    {LABELS.TO_DATE}
                    <TxtBox
                      type={"date"}
                      id="userToDate"
                      defaultValue={DateFunctions.getDate(
                        "thismonth",
                        "to",
                        "YYYY-MM-DD"
                      )}
                    />
                  </div> */}

                <div className="flexRowJustify siderBarBtns">
                  <div></div>
                  <Btn
                    paddingLeft={10}
                    paddingRight={10}
                    text={LABELS.SHOW_TRACK}
                    onClick={getUserTrack}
                    bgColor={COLORS.SAVE_GREEN}
                  />
                  <div></div>
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </>
  );
};

export default withSnackbar(DataDetailsRightSide);
